module.exports = __webpack_public_path__ + "img/Primordial-Process-8-mobile.16de9742.png";